import { render, staticRenderFns } from "./Gangweifenlei.vue?vue&type=template&id=f77c575c&scoped=true&"
import script from "./Gangweifenlei.vue?vue&type=script&lang=js&"
export * from "./Gangweifenlei.vue?vue&type=script&lang=js&"
import style0 from "./Gangweifenlei.vue?vue&type=style&index=0&id=f77c575c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c575c",
  null
  
)

export default component.exports